// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__4TKes","title":"styles_title__wTW4w","subtitle":"styles_subtitle__jQd0M"};